import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { useParams } from "react-router-dom";

import {
  HelpTopicLanguageSwitcher,
  HelpTopicMarkdown,
  useHelpTopicContent,
} from "@ryde/layout";

import {
  HelpTopicsArticleStyled,
  HelpTopicsTopicToolbarStyled,
} from "./help-topics.page.styled";

export const HelpTopicsTopicView: FC = () => {
  const { "*": topicPath } = useParams<{ "*": string }>();

  const helpTopikUrl = topicPath?.replace(/^\/+/, "") || undefined;

  const {
    markdown,
    markdownBasePath,
    isLoading,
    error,
    locale,
    hasHebrewTranslation,
    setLocale,
  } = useHelpTopicContent(helpTopikUrl);

  const languageSwitcher = helpTopikUrl ? (
    <HelpTopicsTopicToolbarStyled>
      <HelpTopicLanguageSwitcher
        locale={locale}
        hasHebrewTranslation={hasHebrewTranslation}
        onLocaleChange={setLocale}
      />
    </HelpTopicsTopicToolbarStyled>
  ) : null;

  if (isLoading) {
    return (
      <HelpTopicsArticleStyled>
        {languageSwitcher}
        <CircularProgress size={30} />
      </HelpTopicsArticleStyled>
    );
  }

  if (error || !markdown) {
    return (
      <HelpTopicsArticleStyled>
        {languageSwitcher}
        <p role="alert">{error || "Topic not found"}</p>
      </HelpTopicsArticleStyled>
    );
  }

  return (
    <HelpTopicsArticleStyled>
      {languageSwitcher}
      <HelpTopicMarkdown
        key={`${locale}-${markdownBasePath}`}
        markdown={markdown}
        markdownBasePath={markdownBasePath}
        dir={locale === "he" ? "rtl" : "ltr"}
      />
    </HelpTopicsArticleStyled>
  );
};
